import { API_URL } from "constants/index";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { SoilStatus, RiskActivities, PScore, GScore, BuildingRegulatoryInfoDTO } from "shared/types/regulatory-info";
import { FileLabel } from "shared/types/file";

export const calculateSoilStatusDotValues = async (entity: any, session: any) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    const soilInfo: BuildingRegulatoryInfoDTO = entity.regulatoryInfo || {};

    // Soil Status
    if ([SoilStatus.NO_POLLUTION, SoilStatus.NO_INFORMATION].includes(soilInfo.soilStatus)) {
        dotValues.green.count++;
        dotValues.green.labels.push("Geen vervuiling / Geen info");
    } else if ([SoilStatus.REMEDIATION_REQUIRED_OWN, SoilStatus.REMEDIATION_REQUIRED_THIRD_PARTY].includes(soilInfo.soilStatus)) {
        dotValues.red.count++;
        dotValues.red.labels.push("Sanering nodig");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Bodemstatus onbekend");
    }

    // Risk Activities
    if ([RiskActivities.NO_RISK_SOIL, RiskActivities.NO_INFORMATION].includes(soilInfo.soilActivities)) {
        dotValues.green.count++;
        dotValues.green.labels.push("Geen risicoactiviteiten / Geen info");
    } else if ([RiskActivities.RISK_SOIL, RiskActivities.RISK_SOIL_PAST].includes(soilInfo.soilActivities)) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Risicoactiviteiten aanwezig of in het verleden aanwezig");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Risicoactiviteiten onbekend");
    }

    // P-Score and G-Score
    if ([PScore.A, PScore.B, GScore.A, GScore.B].includes(soilInfo.pScore) || [PScore.A, PScore.B, GScore.A, GScore.B].includes(soilInfo.gScore)) {
        dotValues.green.count++;
        dotValues.green.labels.push("Goede P-Score / G-Score");
    } 
    
    if ([PScore.C, GScore.C].includes(soilInfo.pScore) || [PScore.C, GScore.C].includes(soilInfo.gScore)) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Matige P-Score / G-Score");
    } 
    
    if ([PScore.D, GScore.D].includes(soilInfo.pScore) || [PScore.D, GScore.D].includes(soilInfo.gScore)) {
        dotValues.red.count++;
        dotValues.red.labels.push("Slechte P-Score / G-Score");
    } 
    
    if(!soilInfo.pScore || soilInfo.pScore == PScore.UNKNOWN) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("P-Score onbekend");
    }

    if(!soilInfo.gScore || soilInfo.gScore == GScore.UNKNOWN) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("G-Score onbekend");
    }

    // Fetch soil document files
    try {
        // Fetch all relevant file logs
        const queryParams = new URLSearchParams();
        if (entity?.id) {
            queryParams.append('buildingId', entity.id);
        }

        const labels = [
            FileLabel.Bodemattest,
            "OBO", // Oriënterend bodemonderzoek
            "BBO"  // Beschrijvend bodemonderzoek
        ];
        queryParams.append('labels', labels.join(','));

        const response = await fetchWithAuth(
            `${API_URL}/file/get-file-logs?${queryParams.toString()}`,
            { method: 'GET' },
            session
        );
        const fileLogs = await response.json();

        // Check for soil certificate documents
        // Check which labels are there

        const oboFiles = fileLogs.filter((file: any) => file.label.includes(FileLabel.OBO));
        const bboFiles = fileLogs.filter((file: any) => file.label.includes(FileLabel.BBO));
        const bodemAttestFiles = fileLogs.filter((file: any) => file.label.includes(FileLabel.Bodemattest));

        if (bodemAttestFiles.length > 0) {
            dotValues.green.count++;
            dotValues.green.labels.push("Bodemattest aanwezig");
        }  else {
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Bodemattest niet aanwezig");
        }

        if (oboFiles.length > 0) {
            dotValues.green.count++;
            dotValues.green.labels.push("OBO aanwezig");
        }

        if (bboFiles.length > 0) {
            dotValues.green.count++;
            dotValues.green.labels.push("BBO aanwezig");
        }
    } catch (error) {
        console.error('Error fetching soil document file logs:', error);
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Kon bodemattestgegevens niet ophalen");
    }

    return dotValues;
};
